import { UploadOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Col, message, Row, Typography, Upload } from "antd";
import React, { useState } from "react";
import Papa from "papaparse";
import { authAxios } from "../utils/session_utils";

const { Title } = Typography;

const AutoPodderAdsAdjust = () => {
	const [fileList, setFileList] = useState<any[]>([]);
	const [loading, setLoading] = useState<boolean>(false);

	const handleBeforeUpload = (file: File) => {
		const isValidFile =
			file.type === "text/csv" ||
			file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
			file.type === "application/vnd.ms-excel" ||
			file.name.endsWith(".csv") ||
			file.name.endsWith(".xlsx") ||
			file.name.endsWith(".xls");

		if (!isValidFile) {
			message.error("Only CSV or Excel (.xlsx, .xls) files are allowed!");
			return Upload.LIST_IGNORE;
		}

		setFileList([
			{
				originFileObj: file,
				name: file.name,
				status: "done",
			},
		]);

		return false;
	};

	const handleOnChange = (info: any) => {
		setFileList(info.fileList);
	};

	const handleUpload = async () => {
		if (!fileList.length) {
			message.error("No file selected");
			return;
		}

		setLoading(true);
		const hideLoading = message.loading("Uploading CSV...", 0);

		try {
			// Create a FormData object to send the file
			const formData = new FormData();
			formData.append("file", fileList[0].originFileObj);

			// Use authAxios instead of fetch
			const config = {
				method: "POST",
				url: `${process.env.REACT_APP_BACK_END_API}/salesforce/ads-adjust`,
				data: formData,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			const response = await authAxios(config);

			const data = response?.data;

            if (!data?.success) {
                throw new Error(data?.message || "Processing failed.");
            }

			message.success(`CSV uploaded successfully`);
			downloadAsCsv(data.rows, data.outputFileName);

			setLoading(false);
			setFileList([]);
			hideLoading();
		} catch (error: any) {
			console.error("Upload error:", error);
			setLoading(false);
			hideLoading();
			message.error(`Upload failed: ${error.message || "Unknown error"}`);
		}
	};

	const downloadAsCsv = (rows: Record<string, any>[], fileName: string) => {
		const csv = Papa.unparse(rows);
		const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
		const url = URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = fileName;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	};
	return (
		<Card
			title={<Title level={4}>AutoPodder Ads Adjust</Title>}
			style={{ maxWidth: 900, margin: "20px auto", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}
			bordered={true}
		>
			<Row gutter={[16, 16]} style={{ marginTop: 16 }}>
				<Col span={24}>
					<Upload
						beforeUpload={handleBeforeUpload}
						onChange={handleOnChange}
						fileList={fileList}
						maxCount={1}
						onRemove={() => setFileList([])}
					>
						<Button icon={<UploadOutlined />} disabled={loading} size="large">
							Select File
						</Button>
					</Upload>
				</Col>
			</Row>
			{fileList.length > 0 && (
				<Row style={{ marginTop: 16 }}>
					<Col span={24}>
						<Alert
							message="File Selected"
							description={`File "${fileList[0].name}" is ready to upload.`}
							type="info"
							showIcon
						/>
					</Col>
				</Row>
			)}

			<Row gutter={[16, 16]} style={{ marginTop: 16 }}>
				<Col span={24}>
					<Button
						type="primary"
						onClick={handleUpload}
						disabled={!fileList.length || loading}
						loading={loading}
						size="large"
						block
					>
						{loading ? "Uploading..." : "Upload"}
					</Button>
				</Col>
			</Row>
		</Card>
	);
};

export default AutoPodderAdsAdjust;
